define.alias("shared/components/shared/card/footer", "media/components/shared/card/footer");